import React from "react";
import { Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import { getCompliacnceId, getFrenchiseeId, getName, partnerDob } from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";


function ComplianceDashboardUnderReview(props) {
    let linecard = props.linecard;
    let navigate = useNavigate();
    let serverError = props.serverError;
    let frenchiseeOnboardingData = props.frenchiseeOnboardingData
    return (
        <>
            <Tab.Pane eventKey="active" className="createdClass">
                <div className="row">
                    <div className="col-12">
                        <div
                            className="oboarding-block-wrapper card-box alert-table text-center partner-wrapper"
                            onScroll={(e) => props.handleScroll(e)}
                        >
                            {frenchiseeOnboardingData.length > 0 ? (
                                <div
                                    className={` ${linecard === "block-active col-division-5"
                                        ? "onboarding-card-wrapper"
                                        : ""
                                        }`}
                                >
                                    {frenchiseeOnboardingData.map((item) => {
                                        return (
                                            <div className={`w-100 bottom-25 ${linecard}`}>

                                                <div className="card-box onboarding-card">
                                                    <div className="client-img-checkbox-wrapper">
                                                        <div className="client-img-wrapper">
                                                            <div className="profile-image">
                                                                {getName(item.name)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="onboarding-card-content">
                                                        <div className="onboarding-card-top">
                                                            <div className="user-email-wrapper">
                                                                <p className="username">
                                                                    <span onClick={() => {
                                                                        getCompliacnceId(item.id)
                                                                        navigate("/compliance-application");
                                                                    }}>{item.name}</span>
                                                                </p>
                                                                <p className="email">{item.email}</p>
                                                            </div>
                                                        </div>

                                                        <div className="clientname-info ">
                                                            <div className="client-data-partner">
                                                                <ul className="call-web-wrapper justify-content-center">
                                                                    <li className="created-time-wrapper">
                                                                        <span className="icon-calendar onboard-pending-icon"></span>
                                                                        <span className="onboard-sm-icon-label">
                                                                            <span>
                                                                                {partnerDob(item.dob)}
                                                                            </span>
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                                <div className="client-info-status">
                                                                    <ul className="call-web-wrapper">
                                                                        <li className="created-time-wrapper">
                                                                            <span className="icon-client-code onboard-pending-icon"></span>
                                                                            <span className="onboard-sm-icon-label">
                                                                                <span>{item.pan}</span>
                                                                            </span>
                                                                        </li>
                                                                        <li>
                                                                            <span className="icon-phone-icon onboard-pending-icon"></span>
                                                                            <span className="onboard-sm-icon-label">
                                                                                <span>{item.mobile}</span>
                                                                            </span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        );
                                    })}
                                </div>
                            ) : serverError ===
                                "Something went wrong, Please try again later." ? (
                                <h4 className="alert-title mb-0">{serverError}</h4>
                            ) : (
                                <div className="alert-title mb-0">
                                    <h3>{Constants.No_Data}</h3>
                                </div>
                            )}
                            {props.scrollLoader && (
                                <div className="loader-center">
                                    <Loader />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Tab.Pane>
        </>
    );
}

export default ComplianceDashboardUnderReview;
